import { useState } from 'react';
import { useMountEffect } from 'primereact/hooks';
import apiClient from '../services/api-client';
import StorageHelper from '../utils/storage-helper';

// Loads a list from `endpoint` once on mount (bearer-authenticated) and exposes it with a reload function.
export const useFetchList = (endpoint) => {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(false);

    const reload = async () => {
        setLoading(true);
        try {
            const response = await apiClient.get(endpoint, {
                headers: {Authorization: 'Bearer ' + StorageHelper.get('token')}
            });
            if (response.data.status === 'SUCCESS') {
                setRows(response.data.responseBody);
            }
        } catch (error) {
            console.error(`Failed to load ${endpoint}:`, error);
        } finally {
            setLoading(false);
        }
    };

    useMountEffect(() => {
        reload();
    });

    return {rows, setRows, reload, loading};
};
